import type { TopSkill } from './top-skills.model';
import type { Skill } from '../skills/skills.model';
import { phpSkill } from '../skills/skills.seed';

export interface GenerateTopSkillsOptions {
  readonly userId: number;
  readonly skills?: readonly Skill[];
}

export function generateTopSkillObjects({
  userId,
  skills = [phpSkill()],
}: GenerateTopSkillsOptions): readonly TopSkill[] {
  return skills.map(skill =>
    generateTopSkillObject({
      skillId: skill.id,
      userId,
      name: skill.name,
      seoUrl: skill.seoUrl,
    }),
  );
}

export interface GenerateTopSkillOptions {
  readonly skillId: number;
  readonly userId: number;
  readonly name: string;
  readonly seoUrl: string;
  readonly isLocal?: boolean;
  readonly usages?: number;
  readonly certified?: boolean;
}

export function generateTopSkillObject({
  skillId,
  userId,
  name,
  seoUrl,
  isLocal = false,
  usages = 0,
  certified = false,
}: GenerateTopSkillOptions): TopSkill {
  return {
    id: skillId,
    userId,
    name,
    seoUrl,
    isLocal,
    usages,
    certified,
  };
}

// --- Mixins ---
export function fromSkill(
  skill: Skill,
): Pick<GenerateTopSkillOptions, 'skillId' | 'name'> {
  return {
    skillId: skill.id,
    name: skill.name,
  };
}
